// SHARED-004: Global player store
import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface PlayerState {
  flop: number;
  agi: number;
  reputation: number;
  baseLevel: number;
  hardwareSlots: number;
  completedProjects: number;
  angelInvestorUsed: boolean;

  addFlop: (amount: number) => void;
  spendFlop: (amount: number) => boolean;
  addAGI: (amount: number) => void;
  spendAGI: (amount: number) => boolean;
  addReputation: (amount: number) => void;
  incrementCompletedProjects: () => void;
  checkAngelInvestor: () => void;
}

export const usePlayerStore = create<PlayerState>()(
  persist(
    (set, get) => ({
  flop: 500,
  agi: 50,
  reputation: 0,
  baseLevel: 1,
  hardwareSlots: 6,
  completedProjects: 0,
  angelInvestorUsed: false,

  addFlop: (amount) => {
    set((s) => ({ flop: s.flop + amount }));
    get().checkAngelInvestor();
  },

  spendFlop: (amount) => {
    const state = get();
    if (state.flop < amount) return false;
    set({ flop: state.flop - amount });
    get().checkAngelInvestor();
    return true;
  },

  addAGI: (amount) =>
    set((s) => ({ agi: s.agi + amount })),

  spendAGI: (amount) => {
    const state = get();
    if (state.agi < amount) return false;
    set({ agi: state.agi - amount });
    return true;
  },

  addReputation: (amount) =>
    set((s) => ({ reputation: s.reputation + amount })),

  incrementCompletedProjects: () =>
    set((s) => ({ completedProjects: s.completedProjects + 1 })),

  checkAngelInvestor: () => {
    const state = get();
    if (state.flop < 100 && !state.angelInvestorUsed) {
      set({ flop: state.flop + 300, angelInvestorUsed: true });
    }
  },
    }),
    {
      name: 'silicon-valley-player',
    }
  )
);
